// TODO: remove duplicate cookie library from bundle
import cookies from 'js-cookie';
import topDomain from '@segment/top-domain';
import { EventEmitter } from 'events';
const COOKIE_KEY = 'tracking-preferences';
// TODO: Make cookie expiration configurable
const COOKIE_EXPIRES = 182;
const topDomainTyped = topDomain;
// TODO: harden against invalid cookies
// TODO: harden against different versions of cookies
export function loadPreferences() {
    const cookie = cookies.get(COOKIE_KEY);
    const preferences = cookie ? JSON.parse(cookie) : undefined;
    if (!preferences) {
        return {};
    }
    return {
        destinationPreferences: preferences.destinations,
        customPreferences: preferences.custom,
    };
}
const emitter = new EventEmitter();
/**
 * Subscribes to consent preferences changing over time and returns
 * a cleanup function that can be invoked to remove the instantiated listener.
 *
 * @param listener a function to be invoked when ConsentPreferences are saved
 */
export function onPreferencesSaved(listener) {
    emitter.on('preferencesSaved', listener);
    return () => emitter.off('preferencesSaved', listener);
}
export function savePreferences({ destinationPreferences, customPreferences, cookieDomain, }) {
    const wd = window;
    if (wd.analytics) {
        wd.analytics.identify({
            destinationTrackingPreferences: destinationPreferences,
            customTrackingPreferences: customPreferences,
        });
    }
    const domain = cookieDomain || topDomainTyped(window.location.href);
    const value = {
        version: 1,
        destinations: destinationPreferences,
        custom: customPreferences,
    };
    cookies.set(COOKIE_KEY, JSON.stringify(value), {
        expires: COOKIE_EXPIRES,
        domain,
    });
    emitter.emit('preferencesSaved', {
        destinationPreferences,
        customPreferences,
    });
}
//# sourceMappingURL=data:application/json;base64,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